export default __webpack_public_path__ + "cb72bf5f088e0ee985876395d24f70ca.png";